import React from 'react';
import { Tab } from '@mui/material';
import '../../../../../styles/components/CreateEvent.css';
import CheckInManage from './CheckInManage';

function Team() {
    return (
        <React.Fragment>
            <section id="create-event-tickets-section">
                <div className="event-creation-stepper">
                    <Tab label="Check in" />
                </div>
                <div className="event-creation-tabs-content">
                    {/* <TicketForm /> */}
                    <CheckInManage />
                </div>
            </section>
        </React.Fragment>
    );
}

export default Team;
